type LLMResponse = {
  content: string;
  error: string;
  responseCode: number;
};

export function parseLLMResponseData(data: unknown): LLMResponse {
  // Only accept proper JSON responses; otherwise, surface an error.
  const parsed =
    typeof data === 'string'
      ? JSON.parse(data)
      : (data as Record<string, unknown>);

  if (
    parsed &&
    typeof (parsed as any).content === 'string' &&
    typeof (parsed as any).error === 'string' &&
    typeof (parsed as any).responseCode === 'number'
  ) {
    return {
      content: (parsed as any).content,
      error: (parsed as any).error,
      responseCode: (parsed as any).responseCode,
    };
  }

  throw new Error(
    'Invalid response format: expected JSON with content, error, responseCode'
  );
}
